import React from 'react';
import './Footer.css';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { SiGumroad, SiUpwork } from 'react-icons/si';
import Reveal from '../motion/Reveal';

const Footer = () => {
  return (
    <Reveal as="footer">
      <span className="footer__logo">Wafa Ben Miloud</span>
      <p className="footer__tagline">AI Software Engineer · Building digital experiences</p>
      <div className="footer__socials">
        <a href="https://www.upwork.com/freelancers/~01fc5f7163d2b11b28?viewMode=1" target="_blank" rel="noreferrer" aria-label="Upwork"><SiUpwork /></a>
        <a href="https://github.com/wafabenmiloud" target="_blank" rel="noreferrer" aria-label="GitHub"><BsGithub /></a>
        <a href="https://www.linkedin.com/in/wafa-ben-miloud-382126181/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><BsLinkedin /></a>
        <a href="https://wafabenmiloud.gumroad.com/" target="_blank" rel="noreferrer" aria-label="Gumroad"><SiGumroad /></a>
      </div>

      <div className="footer__divider"></div>

      <div className="footer__copyright">
        <small>&copy; {new Date().getFullYear()} <span>wafabenmiloud</span>. All rights reserved.</small>
        <small>Built with my <a href="https://wafabenmiloud.gumroad.com/l/portfolio" target="_blank" rel="noreferrer">React portfolio template</a></small>
      </div>
    </Reveal>
  );
};

export default Footer;
